import type { WeaponDef } from '../../sim/defs';
import { PbMode } from '../../sim/pools/BulletPool';
import { Stat } from '../../sim/stats';

/** A03 — TRAQUEUR. « Balles GUIDÉES qui infléchissent leur course vers l'ennemi »
 *  (nœud `arme-traqueur`, 1 800 crédits, ouvert par « 400 ennemis dans une run »).
 *
 *  10 volées/s × 2 projectiles × 10 dégâts = 200 DPS — le MÊME nombre que le
 *  VULCAN, au chiffre près. Elles ne se départagent pas en puissance nominale.
 *
 *  ── Un vrai TYPE de balle, pas un profil de statistiques ──────────────────
 *  C'est la première arme dont le projectile change de NATURE et non seulement
 *  de chiffres : ses balles sont marquées `PbMode.Homing` et pilotées par
 *  `steerSecondaries`, exactement comme un missile secondaire. La conduite vit
 *  déjà dans le moteur ; l'arme ne fait que la POSER sur le tir primaire, via la
 *  statistique catégorielle `bulletMode` (voir `stats.ts`). Aucune ligne de
 *  moteur nouvelle — la même frontière que tout le catalogue défend.
 *
 *  ── Le guidage est DOUX, et c'est ce qui l'équilibre ──────────────────────
 *  La vitesse de virage (`PRIMARY_HOMING_RATE`, dans `playerSystem`) est faible :
 *  la balle infléchit sa course, elle ne verrouille pas. Contre un ennemi qui
 *  dérive latéralement, elle rattrape une partie de l'erreur que le VULCAN aurait
 *  laissée passer — c'est son terrain. Contre une nuée dense, le guidage ne sert
 *  à rien et le round plus fin (voir plus bas) la pénalise : elle est franchement
 *  moins tolérante que le PLASMA sur un alignement approximatif.
 *
 *  ⚠️ Le guidage meurt au premier contact (`Homing < PB_PERSISTENT`) : aucune
 *  traversée multi-cible, donc aucun gain de DPS caché. Le seul avantage est le
 *  taux de touche sur cible mobile, payé par la finesse du round.
 *
 *  ── La contrepartie : des rounds 20 % plus FINS ───────────────────────────
 *  Là où le PLASMA rachète sa latence par un round plus large, le TRAQUEUR
 *  échange dans l'autre sens : le guidage aide à toucher une cible qui bouge,
 *  mais le projectile plus fin pardonne moins l'alignement sur une cible immobile
 *  ou groupée. L'axe qu'il peuple est « visée assistée contre mobiles / mauvais
 *  contre les murs de popcorn », distinct du PLASMA et du FAISCEAU. */
const traqueur: WeaponDef = {
  id: 'traqueur',
  name: 'Traqueur',
  modifiers: [
    // Change la NATURE du projectile — guidé — sans toucher au DPS nominal (le
    // mode n'entre pas dans `dps()`). Le VULCAN reste l'unité de mesure.
    { stat: Stat.BulletMode, op: 'add', value: PbMode.Homing },
    // La contrepartie du guidage : un round 20 % plus fin, moins tolérant sur
    // l'alignement d'une cible immobile. Ne change pas le DPS.
    { stat: Stat.BulletRadius, op: 'mul', value: -0.2 },
  ],
  text: '10 volées/s × 2 × 10 dégâts — 200 DPS, rounds GUIDÉS et plus fins',
};

export default traqueur;
